import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import moment from "moment";

// constants
import { PAN } from "@/store/actions/registeredEventsActions";

// utils
import { getGlobalFormConfig } from "./cmsGlobalData";

export const getMultiDayFormConfig = (
    form,
    formPageConfig = {},
    globalFormConfig = {}
) => {
    const slotEnum =
        get(formPageConfig, "schema.slot.enum") ||
        get(globalFormConfig, "slot.enum") ||
        get(form, "controlSchema.properties.slot.enum") ||
        null;

    const dateEnum =
        get(formPageConfig, "schema.event_start_date.enum") ||
        get(globalFormConfig, "event_start_date.enum") ||
        get(form, "controlSchema.properties.event_start_date.enum") ||
        null;

    return isEmpty(slotEnum) || isEmpty(dateEnum)
        ? null
        : { slotEnum, dateEnum };
};

const deserializeEvent = (event, globalFormConfig, crmEvent = {}) => {
    let data = {};

    if (event) {
        const lodashGet = (key, defaultValue = null) =>
            get(event.attributes, key, defaultValue);
        const city = lodashGet("city.data.attributes.name", "");

        data = {
            ...crmEvent,
            uniqueId: crmEvent.unique_id,
            crmId: crmEvent.crm_fair_id,
            joinUrl: crmEvent.join_url,
            startTime: crmEvent.start_time,
            slotTime: crmEvent.slot,
            cmsId: get(event, "id", ""),
            slug: lodashGet("slug", ""),
            dateTimeIsoFormat: lodashGet("dateTime", ""),
            endTimeIsoFormat: lodashGet("endTime", ""),
            title: lodashGet("title", ""),
            eventType: lodashGet("eventType", ""),
            description: lodashGet("description", ""),
            mobileDescription: lodashGet("mobileDescription", ""),
            coverImage: {
                src: lodashGet("image.data.attributes.url", ""),
                alt: lodashGet("image.data.attributes.alternativeText", ""),
            },
            registrationFee: lodashGet("eventRegistrationFee", ""),
            zoom_id: lodashGet("zoom_id", ""),
            location: city === PAN ? "Online" : city,
            direction: crmEvent.direction,
            formPageContant: lodashGet("formPageConstants", {}),
        };

        if (
            moment(lodashGet("endTime", "")).isAfter(
                moment(lodashGet("dateTime", "")),
                "D"
            )
        ) {
            data.multiDayFormConfig = getMultiDayFormConfig(
                lodashGet("form.data.attributes"),
                lodashGet("formPageConfig") || {},
                globalFormConfig || {}
            );
        }
    }

    return data;
};

const deserializeEventList = (events = [], cmsGlobalData) => {
    const globalFormConfig = getGlobalFormConfig(cmsGlobalData || []);
    return events.map((event) => deserializeEvent(event, globalFormConfig));
};

export { deserializeEvent, deserializeEventList };
